module ViewMode

type ViewMode =
    | Workflow
    | Snapshot
